import { usePage } from "@inertiajs/react";
import { DefaultLayoutWrapper } from "layouts/DefaultLayout";
import Container from "hardcover-ui/components/Container";
import ProfileWrapper from "components/profile/ProfileWrapper";
import UserPromptNav from "components/profile/UserPromptNav";
import { UserPromptPageProps } from "./show.props";
import PromptAnswersPage from "components/profile/PromptAnswersPage";

function UserPromptPage() {
  const { user, prompt } = usePage<UserPromptPageProps>().props;

  return (
    <ProfileWrapper user={user}>
      <Container size="lg" className="pt-4 md:px-2">
        <UserPromptNav username={user.username} />

        <PromptAnswersPage prompt={prompt} />
      </Container>
    </ProfileWrapper>
  );
}

UserPromptPage.layout = DefaultLayoutWrapper;
export default UserPromptPage;